import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Checkbox from '../../../common/Checkbox';
import { withComponentId } from '../../../common/ComponentIdContext';
import ConstCommon from '../../../common/Const';
import ScrollComponent from '../../../common/ScrollComponent';
import CurrentState from '../../../helpers/CurrentState';
import {
  ignoreMappings,
  groupIndicatorsBanking,
  groupIndicators,
} from '../constants';
import { REDUCER_NAME, setHideIndicator } from '../reducer';

class RatioSetting extends PureComponent {
  state = {
    isShowPopup: false,
    top: null,
    left: null,
    keyword: '',
  };
  div = document.createElement('div');
  rootRef = React.createRef();
  popupRef = React.createRef();

  componentDidMount() {
    document.body.appendChild(this.div);
    const { setHideIndicator, componentId } = this.props;
    const currentHideIndicators = CurrentState.get(
      ConstCommon.listComponent.FinancialRatio,
      'hideIndicators',
      componentId,
    );
    if (currentHideIndicators) {
      setHideIndicator(componentId, currentHideIndicators);
      return;
    }

    setHideIndicator(componentId, this.getHideIndicators());
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShowPopup } = this.state;
    const {
      hideIndicators,
      componentId,
      searchParams,
      setHideIndicator,
    } = this.props;
    if (isShowPopup && !prevState.isShowPopup) {
      document.addEventListener('click', this.handleClickOutside);
    }
    if (!isShowPopup && prevState.isShowPopup) {
      document.removeEventListener('click', this.handleClickOutside);
    }
    if (searchParams.isBanking !== prevProps.searchParams.isBanking) {
      setHideIndicator(componentId, this.getHideIndicators());
    }

    if (hideIndicators !== prevProps.hideIndicators) {
      if (searchParams.isBanking) {
        CurrentState.add(
          ConstCommon.listComponent.FinancialRatio,
          'bankingHideIndicators',
          hideIndicators,
        );
      } else {
        CurrentState.add(
          ConstCommon.listComponent.FinancialRatio,
          'nonBankingHideIndicators',
          hideIndicators,
        );
      }
      CurrentState.add(
        ConstCommon.listComponent.FinancialRatio,
        'hideIndicators',
        hideIndicators,
        componentId,
      );
    }
  }

  componentWillUnmount() {
    try {
      document.removeChild(this.div);
    } catch (e) {}
  }

  getHideIndicators = () => {
    const { searchParams } = this.props;
    const defaultHideIndicators = this.getDefaultHideIndicator();
    if (searchParams.isBanking) {
      const bankingHideIndicators = CurrentState.get(
        ConstCommon.listComponent.FinancialRatio,
        'bankingHideIndicators',
      );

      return bankingHideIndicators || defaultHideIndicators;
    }

    const nonBankingHideIndicators = CurrentState.get(
      ConstCommon.listComponent.FinancialRatio,
      'nonBankingHideIndicators',
    );

    return nonBankingHideIndicators || defaultHideIndicators;
  };

  handleClickOutside = e => {
    const isInPopup =
      this.popupRef.current && this.popupRef.current.contains(e.target);
    if (!isInPopup) {
      this.showPopup(false);
    }
  };

  getDefaultHideIndicator = () => {
    const { mapping, defaultIndicators } = this.props;
    const hideIndicators = {};
    Object.keys(mapping).forEach(key => {
      if (!defaultIndicators.includes(key)) {
        hideIndicators[key] = true;
      }
    });

    return hideIndicators;
  };

  onCheckboxChange = (e, key) => {
    const { hideIndicators, setHideIndicator, componentId } = this.props;

    setHideIndicator(componentId, {
      ...hideIndicators,
      [key]: !e.target.checked,
    });
  };

  onTextChange = e => {
    this.setState({
      keyword: e.target.value,
    });
  };

  showPopup = (bool = true) => {
    this.setState({
      isShowPopup: bool,
    });
  };

  getIndicators = () => {
    const { keyword } = this.state;
    const { mapping } = this.props;

    return Object.keys(mapping).filter(key => {
      const text = I18n.t(
        `financialAnalysis.financialRatio.${key}`,
      ).toLowerCase();
      return (
        !ignoreMappings.includes(mapping[key]) &&
        !groupIndicators.includes(key) &&
        !groupIndicatorsBanking.includes(key) &&
        text.includes(keyword.toLowerCase())
      );
    });
  };

  onResetDefault = () => {
    const {
      defaultIndicators,
      setHideIndicator,
      mapping,
      componentId,
    } = this.props;
    const hideIndicators = {};
    Object.keys(mapping).forEach(key => {
      if (!defaultIndicators.includes(key)) {
        hideIndicators[key] = true;
      }
    });
    setHideIndicator(componentId, hideIndicators);
  };

  onClearAll = () => {
    const { mapping, setHideIndicator, componentId } = this.props;
    const indicators = {};
    Object.keys(mapping).forEach(key => {
      indicators[key] = true;
    });
    setHideIndicator(componentId, indicators);
  };

  renderPopup = () => {
    const { keyword, top, left } = this.state;
    const { hideIndicators } = this.props;
    return (
      <div
        ref={this.popupRef}
        style={{
          top: `${top + 24}px`,
          left: `${left}px`,
        }}
        className="ratio-setting-indicators"
      >
        <div className="header">Settings</div>

        <div className="search">
          <input onChange={this.onTextChange} value={keyword} type="text" />
          <i className="icon-search" />
        </div>

        <div className="list">
          <ScrollComponent appendStyle={{ maxHeight: 200 }}>
            {this.getIndicators().map(key => {
              const text = I18n.t(`financialAnalysis.financialRatio.${key}`);

              return (
                <div title={text} key={key} className="indicator">
                  <Checkbox
                    isChecked={!hideIndicators[key]}
                    onChange={e => this.onCheckboxChange(e, key)}
                    name="indicator"
                    label={text}
                  />
                </div>
              );
            })}
          </ScrollComponent>
        </div>

        <div className="footer">
          <div
            onClick={this.onClearAll}
            className="clear-all d-flex align-items-center justify-content-between"
          >
            Clear all
            <i className="icon-cancel" />
          </div>
          <div
            onClick={this.onResetDefault}
            className="reset-default d-flex align-items-center justify-content-between"
          >
            Reset default <i className="icon-reset" />
          </div>
        </div>
      </div>
    );
  };

  setShowPopup = () => {
    const { top, left } = this.rootRef.current.getBoundingClientRect();
    this.setState({
      top,
      left,
      isShowPopup: true,
    });
  };

  render() {
    const { isShowPopup } = this.state;
    return (
      <div
        ref={this.rootRef}
        className="ratio-setting  d-flex align-items-center"
      >
        <div onClick={this.setShowPopup} className="d-flex align-items-center">
          {I18n.t('financialAnalysis.financialRatio.ratioTitle')}
          <i className="icon-settings" />
        </div>
        {isShowPopup && ReactDOM.createPortal(this.renderPopup(), this.div)}
      </div>
    );
  }
}

RatioSetting.propTypes = {};

const mapStateToProps = (state, { componentId }) => ({
  hideIndicators: state[REDUCER_NAME][componentId].hideIndicators,
  searchParams: state[REDUCER_NAME][componentId].searchParams,
});

const mapDispatchToProps = {
  setHideIndicator,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(RatioSetting);
